export const ASSET_COLUMN_TYPES = ["string", "int", "file"];

export const ASSET_TYPE_FORM_EMPTY = {
  name: "",
  version: 1,
  description: "",
  appMeta: [],
  assetMeta: [],
};

export function getAssetTypeAppMeta(assetType) {
  if (!assetType) return [];
  return assetType.appMeta ?? [];
}

export function getAssetTypeAssetMeta(assetType) {
  if (!assetType) return [];
  return assetType.assetMeta ?? assetType.columns ?? [];
}

export function getAssetTypeColumns(assetType) {
  return [...getAssetTypeAppMeta(assetType), ...getAssetTypeAssetMeta(assetType)];
}

export function assetTypeToForm(assetType) {
  if (!assetType) return { ...ASSET_TYPE_FORM_EMPTY, appMeta: [], assetMeta: [] };
  const legacyColumns = assetType.columns ?? [];
  return {
    name: assetType.name ?? "",
    version: assetType.version ?? 1,
    description: assetType.description ?? "",
    appMeta: (assetType.appMeta ?? []).map((col) => ({ key: col.key ?? "", type: col.type ?? "string" })),
    assetMeta: (assetType.assetMeta ?? legacyColumns).map((col) => ({ key: col.key ?? "", type: col.type ?? "string" })),
  };
}

export function formatAssetTypeColumns(assetTypeOrColumns) {
  const columns = Array.isArray(assetTypeOrColumns)
    ? assetTypeOrColumns
    : getAssetTypeColumns(assetTypeOrColumns);
  if (!columns?.length) return "—";
  return columns.map((col) => `${col.key} (${col.type})`).join(", ");
}

function validateColumnSection(columns, seenKeys) {
  const columnErrors = [];
  (columns ?? []).forEach((col, index) => {
    const key = col.key?.trim();
    const row = {};
    if (!key) row.key = "Key is required";
    else if (seenKeys.has(key.toLowerCase())) row.key = "Duplicate key";
    else seenKeys.add(key.toLowerCase());
    if (!ASSET_COLUMN_TYPES.includes(col.type)) row.type = "Select a type";
    if (Object.keys(row).length) columnErrors[index] = row;
  });
  return columnErrors;
}

export function validateAssetTypeForm(form) {
  const errors = {};
  const name = form.name?.trim();
  if (!name) errors.name = "Asset type name is required";

  const version = Number(form.version);
  if (!Number.isInteger(version) || version < 1) {
    errors.version = "Version must be a whole number of 1 or greater";
  }

  const seenKeys = new Set();
  const appMetaErrors = validateColumnSection(form.appMeta, seenKeys);
  const assetMetaErrors = validateColumnSection(form.assetMeta, seenKeys);

  if (appMetaErrors.some(Boolean)) errors.appMeta = appMetaErrors;
  if (assetMetaErrors.some(Boolean)) errors.assetMeta = assetMetaErrors;

  return errors;
}

function normalizeColumnList(columns) {
  return (columns ?? [])
    .map((col) => ({ key: col.key.trim(), type: col.type }))
    .filter((col) => col.key);
}

export function assetTypeFormToPayload(form) {
  return {
    name: form.name.trim(),
    version: Number(form.version),
    description: form.description?.trim() ?? "",
    appMeta: normalizeColumnList(form.appMeta),
    assetMeta: normalizeColumnList(form.assetMeta),
  };
}
